class ProductBeforeAfter extends HTMLElement {
    constructor() {
        super();
        
        this.swiperCheck();
        this.expandContent();
        this.expandImage();
    }

    swiperCheck() {
        let self = this;
        let settings = {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 37,
            pagination: {
                el: ".product-before-after__swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        }

        let beforeAfterSwiper = new Swiper(".product-before-after__swiper", settings);        
        let swiperActive = true;

        if (window.innerWidth <= 989) {
            if (!swiperActive) {
                let beforeAfterSwiper = new Swiper(".product-before-after__swiper", settings);
                swiperActive = true;
            }
        }else{
            if (swiperActive) {
                let beforeAfterSwiper = new Swiper(".product-before-after__swiper", settings);
                beforeAfterSwiper.destroy( true, true);
                swiperActive = false;
            }
        }

        window.addEventListener("resize", () => {
            if (window.innerWidth <= 989) {
                if (!swiperActive) {
                    let beforeAfterSwiper = new Swiper(".product-before-after__swiper", settings);
                    swiperActive = true;
                }
            }else{
                if (swiperActive) {
                    let beforeAfterSwiper = new Swiper(".product-before-after__swiper", settings);
                    beforeAfterSwiper.destroy( true, true);
                    swiperActive = false;
                }
            }
        });

    }
    
    expandContent() {
        let self = this;
        let expandButton = self.querySelector('.product-before-after__expand-button');

        expandButton.addEventListener('click', () => {
            self.classList.toggle("expandable-content--hidden");
        })
    }

    expandImage(){
        let self = this;
        let modal = self.querySelector("#ProductBeforeAfterModal");
        let images = self.querySelectorAll('.product-before-after__image img');
        let modalImg = self.querySelector(".product-before-after__modal__modal-image");
        let closeModal = self.querySelector(".product-before-after__modal-close");

        images.forEach(image => {
            image.onclick = function(){
                modalImg.src = image.src;
                modal.style.display = "block";
            }
        });

        closeModal.onclick = function() {
            modal.style.display = "none";
        }
        modal.addEventListener('click', function(e){   
            if (self.querySelector('.product-before-after__modal-content').contains(e.target)){
            } else{
                modal.style.display = "none";
            }
        });
              
    }
}

customElements.define('product-before-after', ProductBeforeAfter);
